<template>
  <div>
    <SemData></SemData>
  </div>
</template>

<script>
import SemData from '../components/SemData.vue';

export default {
  components: {
    SemData,
  },
};
</script>